export type VariationType = 'Original' | 'Variation #1';

declare global {
  interface Window {
    optimizelyConfig: {
      [experimentName: string]: { variantId: VariationType };
    };
  }
}

export const getOptimizelyVariation = (
  experimentName: string | undefined
): VariationType => {
  if (
    typeof window === 'undefined' ||
    window.optimizelyConfig === undefined ||
    experimentName === undefined
  ) {
    return 'Original';
  }

  return window.optimizelyConfig[experimentName]?.variantId ?? 'Original';
};

export const isOptimizelyVariationActive = (
  currentVariation: string,
  targetVariation: string = 'Variation #1',
  enableForTest: boolean = true
): boolean => {
  const env = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
  // In order to test the experiment in the integration tests
  if (env === 'test' && enableForTest) {
    return true;
  }
  return currentVariation === targetVariation;
};
